export default __webpack_public_path__ + "static/media/Other- Happy Person.4c700d01.jpg";